import Capex_CapexPage from "@Quest/Capex/Pages/CapexPage.vue";

export const routes = [
    {
        path: "/enterprise/capex/:workspaceId/:strategyId",
        component: Capex_CapexPage
    },
]
